// ===== Venue Dashboard Header =====
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useVenueDashboard } from '../contexts/VenueDashboardContext';
import RoleSwitcher from './RoleSwitcher';
import { ArrowLeftIcon, HomeIcon } from '@heroicons/react/24/outline';

const VenueDashboardHeader = ({ title, showBack = true }) => {
  const navigate = useNavigate();
  const { venue } = useVenueDashboard();

  return (
    <header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        backgroundColor: 'white',
        borderBottom: '1px solid #e5e7eb',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
      }}
      data-testid="venue-dashboard-header"
    >
      {/* Left Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {showBack && (
          <button
            onClick={() => navigate(-1)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '36px',
              height: '36px',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              backgroundColor: 'white',
              cursor: 'pointer',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
            data-testid="back-button"
          >
            <ArrowLeftIcon style={{ width: '18px', height: '18px', color: '#374151' }} />
          </button>
        )}
        
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '36px',
            height: '36px',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            backgroundColor: 'white',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
          title="Back to Map"
          data-testid="home-button"
        >
          <HomeIcon style={{ width: '18px', height: '18px', color: '#374151' }} />
        </button>

        <div>
          <h1 style={{ 
            fontSize: '18px', 
            fontWeight: '700', 
            color: '#1f2937',
            margin: 0
          }}>
            {title || 'Venue Dashboard'}
          </h1>
          {venue && (
            <p style={{ 
              fontSize: '13px', 
              color: '#6b7280',
              margin: '2px 0 0 0'
            }}>
              {venue.name}
            </p>
          )}
        </div>
      </div>

      {/* Right Section - Role Switcher */}
      <RoleSwitcher />
    </header>
  );
};

export default VenueDashboardHeader;
